module.exports = __webpack_public_path__ + "static/axa-colpatria-0eba363fc7108bc47b575b4d90567084.png";